"use strict";
/**
 * @module React Input components
 * Wrapper over all input components
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var text_input_component_1 = require("./text-input.component");
var select_component_1 = require("./select.component");
var pp_react_1 = require("@paypalcorp/pp-react");
var pp_react_checkbox_1 = require("@paypalcorp/pp-react-checkbox");
var input = function (props) {
    var inputElement = null;
    switch (props.elementType) {
        case ('input'):
            inputElement = React.createElement(text_input_component_1.default, { id: props.id, name: props.id, isDirty: props.isTouched, defaultValue: props.value, label: props.elementConfig.placeholder, errorMessage: props.elementConfig.suggestionText, onChange: props.changed, onBlur: props.changed, hasError: props.isInvalid && props.shouldValidate && props.isTouched });
            break;
        case ('select'):
            inputElement = (React.createElement(select_component_1.default, { id: props.id, name: props.id, value: props.value, hasError: props.isInvalid && props.shouldValidate && props.isTouched, label: props.elementConfig.placeholder, onChange: props.changed }, props.elementConfig.options.map(function (option) { return (React.createElement("option", { key: option.optionId, value: option.optionId }, option.optionValue)); })));
            break;
        case ('checkbox'):
            inputElement = (
            // issue with pp-react component checkbox with ts: https://github.paypal.com/PayPal-UI-R/pp-react/issues/188
            // @ts-ignore
            React.createElement(pp_react_checkbox_1.Checkbox, { className: props.className, id: props.id, checked: props.value, onChange: props.changed, name: props.id, label: React.createElement(pp_react_1.Text, tslib_1.__assign({ size: props.elementConfig.labelClass }, props.elementConfig.labelSize), props.elementConfig.label) }));
            break;
    }
    return inputElement;
};
exports.default = input;
